<template>
  <div class="">
    <template v-if="answer.type === 'jpg'|| answer.type === 'jpeg' || answer.type === 'jpg'">
      <v-img :src="url" width="100%"/>
    </template>
    <template v-else-if="answer.type === 'image/jpeg'|| answer.type === 'image/png'">
      <v-img :src="url" width="100%"/>
    </template>
    <template v-else-if="answer.type === 'application/pdf'">
      <embed :type="answer.type" :src="url" width="100%" height="500px">
    </template>
    <template v-else>
      <embed :type="answer.type" :src="url" width="100%" height="500px">
    </template>
  </div>
</template>

<script>
export default {
  props: {
    answer: {
      type: Object
    }
  },
  data: () => ({
    blob: null,
    url: null,
  }),
  created() {
    this.loadData()
  },
  methods: {
    loadData() {
      this.axios({
        method: 'GET',
        url: `api/sessions/${this.$route.params.session_id}/answers/${this.answer.id}`,
        responseType: 'blob'
      })
          .then(({data}) => {
            this.blob = data
            this.url = URL.createObjectURL(data)
          })
    }
  }


}
</script>